/**
 * Returns a promise that will be resolved with the response once the provided XHR succeeds, or rejected if the provided XHR fails.
 * @param xhr
 * @returns {Promise<any>}
 */
async function xhrWrapper(xhr) {
    const promise = new Promise((resolve, reject) => {
        const previousOnReadyStateChangeHandler = xhr.onreadystatechange;

        function processsXhrChange() {
            // invoke the previous handler if one exists
            let innerError = null;
            if (previousOnReadyStateChangeHandler) {
                try {
                    previousOnReadyStateChangeHandler.apply(xhr, arguments);
                } catch (e) {
                    innerError = e;
                }
            }

            const rethrowInnerError = () => {
                // rethrow any error thrown by another state change handler
                if (innerError) {
                    throw innerError;
                }
            };

            // don't do anything if the request is still in-flight
            if (xhr.readyState !== 4) {
                rethrowInnerError();
                return;
            }

            if (xhr.status === 200) {
                resolve(xhr.responseText);
            } else {
                const error = new Error(
                    `XHR failed with status=${xhr.status} and statusText="${xhr.statusText}"`
                );
                reject(error);
            }

            rethrowInnerError();
        }

        xhr.onreadystatechange = processsXhrChange;

        // go ahead and invoke the handler immediately in case the request has already finished
        processsXhrChange();
    });

    return promise;
}

export default xhrWrapper;
export {xhrWrapper};
